import { lazy } from 'react';
export const lazyLoadSalesApp = () => lazy(() => import('./SalesApp'));
export const lazyLoadGoalsApp = () => lazy(() => import('./GoalsApp'));
export const lazyLoadMiniGoalsApp = () => lazy(() => import('./GoalsMiniApp'));
export const lazyLoadCustomersApp = () => lazy(() => import('./CustomersApp'));
export const lazyLoadCompetitionApp = () => lazy(() => import('./CompetitionApp'));
